import React from 'react';
import Immutable from 'immutable'
import * as ImmutablePropTypes from 'react-immutable-proptypes';

import RaisedButton from 'material-ui/RaisedButton';
import SelectionManager, {SelectionStates} from './SelectionManager'


class EditorPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeAction:null,
        }
        this.selectionAction = {
            id:'selection',
            label:'select',
            handleSelection : () => {},  // noop, selection manager handles that for us
            handleItemClick : () => {},  // noop, selection manager handles that for us
        }
        this.actionMap = {};
        [].concat(this.selectionAction).concat(this.props.actions)
            .forEach(a => this.actionMap[a.id]=a);

        this.currentSelection = Immutable.Set();
        this.handleActionClick = this.handleActionClick.bind(this);
        this.handleItemClick = this.handleItemClick.bind(this);
        this.handleSelection = this.handleSelection.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }
    toggleAction(action) {
        if( this.state.activeAction !== action ) {
            this.setState({activeAction:action});
        } else {
            this.setState({activeAction:null});
        }
    }
    handleActionClick(actionId) {
        const action = this.actionMap[actionId];
        if( this.state.activeAction === this.selectionAction) {
            if( action === this.selectionAction) {
                this.toggleAction(action);
            } else {
                action.handleSelection( this.props.editorId, this.currentSelection, this.props.mutations, this.props.dispatch); // let action do it's thing with the selection
            }
        } else {
            this.toggleAction(action) // make the action active
        }
    }
    isActionActive(action) {
        return this.state.activeAction && this.state.activeAction.id === action.id;
    }
    handleItemClick(item, type) {
        if( this.state.activeAction !== null) {
            this.state.activeAction.handleItemClick(this.props.editorId, type, item, this.props.mutations, this.props.dispatch);
        }
    }
    handleSelection(selection) {
        this.currentSelection = selection;
    }
    handleSave() {
        this.props.onSave();
    }

    getActions() {
        const actions = this.props.actions;
        return [].concat(this.selectionAction).concat(actions).map(a => {
            return ( <RaisedButton
                key={a.id}
                onClick={() => this.handleActionClick(a.id)}
                label={a.label}
                primary={this.isActionActive(a)}/>)
        });
    }
    render() {

        const MyElement = this.props.children;
        return (
            <div>
                <div className="editor-actions">{this.getActions()}
                <RaisedButton label='Save' onClick={this.handleSave}/>
                </div>
                <div className="editor-content">
                    <SelectionManager handleSelection={this.handleSelection}
                                      handleClick={this.handleItemClick}
                                      selectionState={
                                          (this.state.activeAction === this.selectionAction)?
                                          SelectionStates.ENABLED: SelectionStates.DISABLED}

                    >
                        { React.cloneElement(MyElement, {
                            ...this.props,
                        })}
                    </SelectionManager>
                </div>
            </div>
        );
    }
}
/*

 */
EditorPanel.propTypes = {
    actions: React.PropTypes.array.isRequired,
    onSave: React.PropTypes.func.isRequired,
    mutations:ImmutablePropTypes.map.isRequired,
    editorId:React.PropTypes.string.isRequired,
}
export default EditorPanel;


// WEBPACK FOOTER //
// ./src/ui/components/editor/Editor.js